import * as React from 'react';

import iconUrl from './Bubbles.svg';

type IBubblesProps = React.ImgHTMLAttributes<HTMLImageElement>;

export function Bubbles(props: IBubblesProps) {
  return <img {...props} width="66" height="42" src={iconUrl} alt="" />;
}
